
























































































































import Vue from "vue";
import { get_file_size, validate_file_type } from "@/utils/global";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  RECOMMEND_JOB_PROFILES,
  ADD_CANDIDATE_CVS
} from "@/store/modules/recruiter/constants";
import {
  UploadedFile,
  ValidateFileType
} from "@/interfaces/shared/file_validation";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import { SiteDirections } from "@/store/modules/common/interfaces";
import { SITE_DIRECTION } from "@/store/modules/common/constants";
import { VIEW_JOB_STATE } from "@/store/modules/common/constants";
import { UploadCvFile } from "@/interfaces/recruiter/jobs/post_job/upload_job_file";
export default Vue.extend({
  name: "UploadResumeFiles",
  data(): UploadCvFile {
    return {
      resume_files: [],
      selected_files: [],
      drop_file_image: require("@/assets/illustrations/file.svg"),
      error: false,
      error_message: "",
      file_id: 1,
      is_valid: false,
      post_job_loading: false
    };
  },
  computed: {
    SiteDirections() {
      return SiteDirections;
    },
    ...mapGetters("common", {
      get_site_direction: SITE_DIRECTION
    })
  },
  methods: {
    ...mapMutations({
      root_error: ROOT_ERROR,
      root_notification: ROOT_NOTIFICATION
    }),
    ...mapActions("recruiter", {
      add_candidate_with_cvs: ADD_CANDIDATE_CVS
    }),
    ...mapMutations("common", {
      set_view_job_state: VIEW_JOB_STATE
    }),
    ...mapMutations("recruiter", {
      set_recommend_job_profiles: RECOMMEND_JOB_PROFILES
    }),
    get_file_size,
    /**
     * Process user selected files, through drag & drop
     * @param value{DragEvent}
     */
    process_dropped_files(value: DragEvent) {
      if (value && value.dataTransfer) {
        const files: File[] = Array.from<File>(value.dataTransfer.files);
        this.validate_file(files);
      }
    },
    /**
     * Process user selected files, through file uploader
     * @param files {File} => Selected file
     */
    process_selected_files(files: File[]) {
      this.validate_file(files);
    },

    /**
     * Validate selected file type & size: .docs, .pdf & .txt are valid types
     * @param files{File} => selected file
     * @return boolean
     */
    validate_file(files: File[]) {
      for (let file of files) {
        const valid_file = this.validate_individual_file(file);
        const obj: UploadedFile = {
          file,
          error: !valid_file.valid,
          error_message: valid_file.msg,
          id: this.file_id
        };
        this.selected_files.push(obj);
        this.file_id += 1;
      }
      this.valid_files();
    },
    valid_files() {
      this.is_valid = true;
      for (let file of this.selected_files) {
        if (file.error) {
          this.is_valid = false;
          break;
        }
      }
    },
    /**
     * Validate selected file type: .docs, .pdf & .txt are valid types
     * @param file {File} => selected file
     * @return boolean
     */
    validate_individual_file(file: File): ValidateFileType {
      if (file.size > 3e7) {
        return {
          valid: false,
          msg: this.$t("recruiter.file-size-rule").toString()
        };
      } else if (
        validate_file_type("text", file) ||
        validate_file_type("pdf", file) ||
        validate_file_type("word", file)
      ) {
        return {
          valid: true,
          msg: ""
        };
      } else {
        return {
          valid: false,
          msg: this.$t("recruiter.allowed-files-rule").toString()
        };
      }
    },
    remove_job_file(file: UploadedFile) {
      this.selected_files = this.selected_files.filter(
        (_file) => _file.id !== file.id
      );
      this.valid_files();
    },
    /**
     * Submit form
     */
    async submit_form() {
      this.post_job_loading = true;
      const obj = new FormData();
      this.selected_files.forEach((a) => {
        obj.append("candidate_resume", a.file);
      });
      const response = await this.add_candidate_with_cvs(obj);

      this.post_job_loading = false;
      if (response) {
        let duplicates = `Duplicate files (${
          response.duplicates.length
        }) ${response.duplicates.map((item: any) => item.file).join(", ")} `;
        let failed = `Failed to add files (${
          response.failed.length
        }) ${response.failed.map((item: any) => item.file).join(", ")}`;
        let msg = `Successfully added files (${response.added.length}), ${failed}, ${duplicates}`;
        this.root_notification(msg);
      } else {
        this.root_error(this.$t("failed to upload cvs"));
      }
      this.$router.push("/recruiter/jobs");
    },
    close_upload() {
      console.log("close called");
      this.$emit("close_upload");
    }
  }
});
